import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';

function AssignCompanyModal({ isOpen, onClose, driverId, onAssign }) {
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      fetchCompanies();
    }
  }, [isOpen]);

  const fetchCompanies = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('profiles')
        .select('*')
        .eq('user_type', 'company')
        .order('company_name', { ascending: true });

      if (error) throw error;
      setCompanies(data);
    } catch (error) {
      console.error('Error fetching companies:', error);
    } finally {
      setLoading(false);
    }
  };
  console.log(selectedCompany, 'companies');
  const handleAssign = async () => {
    if (!selectedCompany) return;

    try {
      setLoading(true);
      const { error } = await supabase
        .from('profiles')
        .update({
          company_id: selectedCompany,
          user_type: 'company_driver',
          company: companies.find((company) => company.id === selectedCompany)
            .company_name,
        })
        .eq('id', driverId);

      if (error) throw error;

      onAssign();
      onClose();
    } catch (error) {
      console.error('Error assigning company:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-semibold mb-4">Firma Ata</h2>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Firma Seçin
          </label>
          <select
            value={selectedCompany}
            onChange={(e) => setSelectedCompany(e.target.value)}
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            disabled={loading}
          >
            <option value="">Firma Seçin</option>
            {companies.map((company) => (
              <option key={company.id} value={company.id}>
                {company.company_name}
              </option>
            ))}
          </select>
        </div>

        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 hover:text-gray-800"
            disabled={loading}
          >
            İptal
          </button>
          <button
            onClick={handleAssign}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:bg-blue-300"
            disabled={!selectedCompany || loading}
          >
            {loading ? 'İşleniyor...' : 'Ata'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AssignCompanyModal;
